/**
 * Creates a shallow copy of the given object, excluding specified properties.
 *
 * @param {any} obj - The object to copy.
 * @param {string[]} excludeKeys - Optional array of property keys to exclude from the copy.
 * @returns {any} A new object with copied properties.
 */
export function cloneObject(obj, excludeKeys = []) {
    const result = Object.create(Object.getPrototypeOf(obj));
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && excludeKeys.indexOf(key) === -1) {
            result[key] = obj[key];
        }
    }
    return result;
}
/**
 * Transforms an array of ToolbarItemModel objects into an array of ItemModel objects.
 *
 * @param {IToolbarItemModel[]} items - The toolbar items to transform.
 * @returns {ItemModel[]} The transformed toolbar items.
 */
export function transformIntoToolbarItem(items) {
    return items.map((item) => ({
        id: item.id,
        prefixIcon: item.iconCss,
        tooltipText: item.tooltipText,
        text: item.text,
        cssClass: item.cssClass,
        disabled: item.disabled,
        visible: item.visible,
        tabIndex: item.tabIndex,
        template: item.template,
        type: item.type,
        htmlAttributes: item.htmlAttributes,
        command: item.command
    }));
}
export function sanitizeBlockActionItems(items) {
    return items.map((item) => ({
        id: item.id,
        label: item.label,
        iconCss: item.iconCss,
        disabled: item.disabled,
        tooltip: item.tooltip,
        shortcut: item.shortcut
    }));
}
export function sanitizeCommandMenuItems(items) {
    return items.map((item) => ({
        id: item.id,
        type: item.type,
        disabled: item.disabled,
        iconCss: item.iconCss,
        label: item.label,
        groupBy: item.groupBy,
        tooltip: item.tooltip,
        shortcut: item.shortcut
    }));
}
export function sanitizeLabelItems(items) {
    return items.map((item) => ({
        id: item.id,
        text: item.text,
        groupBy: item.groupBy,
        labelColor: item.labelColor,
        iconCss: item.iconCss
    }));
}
export function sanitizeContextMenuItems(items) {
    return items.map((item) => ({
        id: item.id,
        text: item.text,
        iconCss: item.iconCss,
        separator: item.separator,
        shortcut: item.shortcut,
        items: sanitizeContextMenuItems(item.items)
    }));
}
export function sanitizeHeadingProps(props) {
    const sanitizedInnerProps = props ? Object.assign({}, props) : {};
    const level = sanitizedInnerProps.level;
    if (!Number.isInteger(level) || level < 1 || level > 4) {
        sanitizedInnerProps.level = 1;
    }
    return sanitizedInnerProps;
}
